<template>
  <v-card :disabled="loading" :loading="loading">
    <v-card-title>
      {{ $t("config_academic.title") }}
    </v-card-title>
    <v-card-text class="px-1 px-md-3 px-xl-6">
      <v-tabs v-model="level_tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="(level, i) in levels" :key="i">
          <h3>
            {{ level.LEVEL_NAME_EN }}
          </h3>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="level_tab" touchless>
        <v-tab-item v-for="(level, i) in levels" :key="i">
          <v-card flat>
            <v-card-text class="px-1 px-md-3 px-xl-6">
              <v-btn
                color="success"
                @click="$refs.addEditDialog.open_add_modal(level.LEVEL_ID)"
                class="mt-3"
              >
                <v-icon>mdi-plus</v-icon>{{ $t("config_academic.addnew") }}
              </v-btn>
              <v-simple-table
                fixed-header
                min-height="300px"
                class="config-scroll-table mt-3 text-no-wrap text-center"
              >
                <thead class="blue-grey darken-1">
                  <tr>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.edit") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.delete") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      #
                    </th>
                    <th v-if="level.LEVEL_ID > '1'" class="white--text">
                      {{ $t("config_academic.sub_level_id") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.year") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.semester") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.start_datetime_system") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.start_datetime_academic") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.end_datetime_academic") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{
                        $t(
                          "config_academic.start_datetime_config_teach_table"
                        )
                      }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{
                        $t("config_academic.end_datetime_config_teach_table")
                      }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.start_datetime_midterm") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.end_datetime_midterm") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.start_datetime_final") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.end_datetime_final") }}
                    </th>
                    <template v-if="level.LEVEL_ID == '1'">
                      <th class="white--text text-center font-weight-regular">
                        {{ $t("config_academic.start_datetime_pre_regis") }}
                      </th>
                      <th class="white--text text-center font-weight-regular">
                        {{ $t("config_academic.end_datetime_pre_regis") }}
                      </th>
                    </template>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.start_datetime_regis") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.end_datetime_regis") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.start_datetime_add_change") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.end_datetime_add_change") }}
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      {{ $t("config_academic.start_datetime_withdraw") }}
                    </th>
                    <th
                      class="white--text text-center font-weight-regular last-cell"
                    >
                      {{ $t("config_academic.end_datetime_withdraw") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(academic_item, index) in listFilter(
                      config_academics,
                      level.LEVEL_ID,
                      'LEVEL_ID'
                    )"
                    v-bind:key="academic_item.ID"
                  >
                    <td>
                      <v-btn
                        small
                        color="warning"
                        v-on:click="
                          $refs.addEditDialog.open_edit_modal(academic_item)
                        "
                      >
                        <v-icon>mdi-pencil</v-icon
                        >{{ $t("config_academic.edit") }}
                      </v-btn>
                    </td>
                    <td>
                      <v-btn
                        small
                        color="error"
                        @click="open_delete_modal(academic_item)"
                      >
                        <v-icon>mdi-delete</v-icon
                        >{{ $t("config_academic.delete") }}
                      </v-btn>
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td v-if="level.LEVEL_ID > '1'">
                      <!-- <h5 v-if="academic_item.SUB_LEVEL_ID == 1">4+1</h5> -->
                      <v-icon v-if="academic_item.SUB_LEVEL_ID == '1'">
                        mdi-check-bold
                      </v-icon>
                    </td>
                    <td>{{ academic_item.YEAR }}</td>
                    <td>{{ academic_item.SEMESTER }}</td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.START_DATETIME_SYSTEM, true)"
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.START_DATETIME_ACADEMIC, true)"
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.END_DATETIME_ACADEMIC, true)"
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="
                        dt(
                          academic_item.START_DATETIME_CONFIG_TEACH_TABLE,
                          true
                        )
                      "
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="
                        dt(
                          academic_item.END_DATETIME_CONFIG_TEACH_TABLE,
                          true
                        )
                      "
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.START_DATETIME_MIDTERM, true)"
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.END_DATETIME_MIDTERM, true)"
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.START_DATETIME_FINAL, true)"
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.END_DATETIME_FINAL, true)"
                    ></td>
                    <template v-if="level.LEVEL_ID == '1'">
                      <td
                        class="font-weight-bold"
                        v-html="
                          dt(academic_item.START_DATETIME_PRE_REGIS, true)
                        "
                      ></td>
                      <td
                        class="font-weight-bold"
                        v-html="dt(academic_item.END_DATETIME_PRE_REGIS, true)"
                      ></td>
                    </template>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.START_DATETIME_REGIS, true)"
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.END_DATETIME_REGIS, true)"
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.START_DATETIME_ADD_CHANGE, true)"
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.END_DATETIME_ADD_CHANGE, true)"
                    ></td>
                    <td
                      class="font-weight-bold"
                      v-html="dt(academic_item.START_DATETIME_WITHDRAW, true)"
                    ></td>
                    <td
                      class="font-weight-bold last-cell"
                      v-html="dt(academic_item.END_DATETIME_WITHDRAW, true)"
                    ></td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <ConfigAcademicAddEditDialog
      ref="addEditDialog"
      :toggle_loading="toggle_loading"
    />

    <ConfigAcademicDeleteDialog
      v-model="showing_delete_modal"
      :title="$t('config_academic.title')"
      :text="
        to_delete_item
          ? ` ${to_delete_item.SEMESTER}/${to_delete_item.YEAR}`
          : ''
      "
      :deleteFunction="delete_config_academic"
    />
  </v-card>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import ConfigAcademicAddEditDialog from "./components/ConfigAcademicAddEditDialog";
import ConfigAcademicDeleteDialog from "./components/ConfigAcademicDeleteDialog";
import {
  objectTranslator,
  dateTimeFromDBTranslatorFull as dt,
} from "@/helper/translator";
import { getYearsModified } from "@/helper/dateTime";
import { getById } from "@/helper/filter";
import { listFilter } from "@/helper/filter";
import ConfigProvider from "@/services/config.provider";
// import RefProvider from "@/services/ref.provider";

// const refProvider = new RefProvider();
const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

export default {
  name: "ConfigAcademic",
  data: function() {
    return {
      loading: false,
      level_tab: null,
      // config_academics: [],

      showing_delete_modal: false,

      to_delete_id: null,
      to_delete_item: null,

      levels: [
        {
          LEVEL_ID: "1",
          LEVEL_NAME_EN: "ปริญญาตรี",
          LEVEL_NAME_TH: "ปริญญาตรี",
        },
        {
          LEVEL_ID: "2",
          LEVEL_NAME_EN: "บัณฑิตศึกษา (4+1, โท, เอก)",
          LEVEL_NAME_TH: "บัณฑิตศึกษา (4+1, โท, เอก)",
        },
      ],
      // all_date_time: [],
    };
  },
  components: {
    ConfigAcademicAddEditDialog,
    ConfigAcademicDeleteDialog,
  },
  computed: {
    ...mapOfficerConfigFields({
      config_academics: "config_academics",
    }),
  },
  methods: {
    dt,
    objectTranslator,
    getYearsModified,
    listFilter,
    getById,
    toggle_loading(status) {
      this.loading = status;
    },
    open_delete_modal: function(item) {
      this.to_delete_id = item.ID;
      this.to_delete_item = item;
      this.showing_delete_modal = true;
    },
    delete_config_academic: async function() {
      this.loading = true;
      let response = await configService
        .deleteAcademics({
          id: this.to_delete_id,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
      this.showing_delete_modal = false;
      this.$store.dispatch("officerConfig/getAcademics");
      if (response && response.status)
        this.$toasted.success(this.$t("toasted.delete_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_delete"));
      this.loading = false;
    },
  },
  mounted: function() {
    // this.$store.dispatch(this.levels);
    this.$store.dispatch("officerConfig/getAcademics");
    // this.all_date_time = all_date_time;
  },
};
</script>

<style>
th {
  letter-spacing: 1px;
}

.config-scroll-table > .v-data-table__wrapper {
  max-height: calc(100vh - 300px);
}

.config-scroll-table.v-data-table--fixed-header
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  background-color: #546e7a;
}
</style>
